<template>
  <div class="tolead">
    <div style="margin-bottom: 20px; display: flex; justify-content: space-between">
      <div>
        <el-select v-model="value" placeholder="请选择" @change="ProjectChange">
          <el-option v-for="(item, index) in Project" :key="index" :label="item.Name" :value="item.Id"></el-option>
        </el-select>
        &nbsp;
        <el-date-picker
          v-model="pickVal"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <!-- 纳排切换 -->
      <template>
        <div style="display: flex" v-if="value != 'all'">
          <el-select clearable v-model="Questionnairevalue" placeholder="问卷列表选择" @change="wenjuanChange">
            <el-option v-for="(item, index) in CRFSurface" :key="index" :label="item.questionnaireName" :value="item.Id"></el-option>
          </el-select>
          <el-button @click="toNapai" type="primary">纳排标准查询</el-button>
        </div>
      </template>
    </div>
    <div style="display: flex; margin-bottom: 20px" class="topDiv">
      <div class="statistics-patient">
        <div class="statistics-title">
          <span></span>
          <span>系统患者数</span>
        </div>
        <div class="patient-top">
          <div>
            <div class="patient-content">
              <span>当前总数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype1.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
          <div>
            <div class="patient-content">
              <span style="color: #fff">本季总数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientQTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype1.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
          <div>
            <div class="patient-content">
              <span style="color: #fff">本年总数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientYTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype1.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
        </div>
        <div class="patient-bottom">
          <div>
            <div class="patient-content">
              <span>年随访数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientYCallTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype2.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
          <div>
            <div class="patient-content">
              <span>季随访数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientQCallTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype2.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
          <div>
            <div class="patient-content">
              <span>月随访数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientMCallTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype2.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
          <div>
            <div class="patient-content">
              <span>周随访数</span>
              <div class="report-flex">
                <p>{{ NumberOfPatients.PatientWCallTotal }}</p>
                <img src="../../assets/image/taskmanagement/projecttype2.png" alt style="width: 27px; height: 27px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="total-number">
        <div style="display: flex; margin-left: 22px; margin-top: 50px">
          <div v-for="(item, index) in followNumber" :key="index" class="follow-number">{{ item }}</div>
        </div>
        <div style="margin-left: 22px; margin-top: 17px" class="bottomdiv">
          <span>随访总人次数</span>
        </div>
      </div>
      <div class="statistics-img-content">
        <div class="statistics-title">
          <span></span>
          <span>随访情况</span>
        </div>
        <div id="staisticsSF" style="width: 580px; height: 240px"></div>
      </div>
    </div>
    <div class="statistics_middle">
      <div class="statistics_middle_left">
        <div
          style="
            box-sizing: border-box;
            padding: 15px;
            margin-bottom: 30px;
            margin-right: 20px;
            width: 48%;
            min-height: 350px;
            aspect-ratio: 500/350;
            float: left;
            background: rgba(255, 255, 255, 0.39);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
          "
        >
          <div class="statistics-title">
            <span></span>
            <span>年龄性别分布图</span>
          </div>
          <div id="staisticsA" style="width: 470px; height: 300px"></div>
        </div>
        <div
          style="
            box-sizing: border-box;
            padding: 15px;
            margin-bottom: 30px;
            width: 48%;
            min-height: 350px;
            aspect-ratio: 500/350;
            float: left;
            background: rgba(255, 255, 255, 0.39);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
          "
        >
          <div class="statistics-title">
            <span></span>
            <span>患者年龄概览</span>
          </div>
          <div id="staisticsC" style="width: 500px; height: 300px"></div>
        </div>
        <div
          style="
            box-sizing: border-box;
            padding: 15px;
            margin-right: 20px;
            width: 48%;
            min-height: 270px;
            aspect-ratio: 500/270;
            float: left;
            background: rgba(255, 255, 255, 0.39);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
          "
          class="staisticsB"
        >
          <div class="statistics-title">
            <span></span>
            <span>出院方式</span>
          </div>
          <div id="staisticsB" style="width: 470px; height: 230px"></div>
        </div>
        <div
          style="
            box-sizing: border-box;
            padding: 15px;
            width: 48%;
            min-height: 270px;
            aspect-ratio: 500/270;
            float: left;
            background: rgba(255, 255, 255, 0.39);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
          "
        >
          <div class="statistics-title">
            <span></span>
            <span>入院方式</span>
          </div>
          <div id="staisticsD" style="width: 470px; height: 230px"></div>
        </div>
      </div>
      <div class="statistics_middle_right">
        <div class="statistics-title">
          <span></span>
          <span>患者分布区域</span>
        </div>
        <div id="StaisticsMap" style="min-width: 780px; min-height: 600px; aspect-ratio: 780/600"></div>
      </div>
    </div>
    <napai :questionnaireName="questionnaireName" :projectName="projectName" :Qid="Questionnairevalue" :id="ProjectId" @closeDialog="closeDialog" v-if="showNapai" ref="naPai"></napai>
  </div>
</template>

<script>
import '@/assets/china.js';
import napai from '@/components/napai.vue';
import { ArrayZero } from '@/utils/filter';
import * as echarts from 'echarts';
import china from 'echarts/map/json/china.json';
import Statistics from '../../api/Statistics';
import derive from '../../api/derive';
echarts.registerMap('china', china);
export default {
  name: 'statistics',
  components: {
    napai
  },
  data() {
    return {
      questionnaireName: '',
      Questionnairevalue: '',
      CRFSurface: [],
      projectName: '',
      ProjectId: '',
      showNapai: false,
      // PatientCallTotal:'',//随访总人次数
      Project: [],
      value: '',
      followNumber: [],
      total: 0,
      NumberOfPatients: {}, //系统患者数.
      Part1: [], //年龄分类人数图
      Part2: [], //全部AI有效随访人群中不同年龄
      Part3: [], //最近一月内AI有效随访人群中不同年龄
      Part4: [], //数量类型占比
      Part5: [], //AI电话接通数
      Part6: [], //患者分布区域
      NoticeMsg: [], //追踪通知
      TraceMsg: [], //消息通知
      list: [{ name: '本季数' }, { name: '本月数' }, { name: '本周数' }, { name: '最近3天' }],
      arr: [{ name: '男性' }, { name: '女性' }, { name: '女性' }, { name: '最近一周男性接通' }, { name: '最近一周女性接通' }],
      arrlist: [],
      devicePixelRatio: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      pickVal: '',
      total2: 0
    };
  },
  created() {
    // this.ProjectList()
  },
  mounted() {
    this.devicePixelRatio = document.documentElement.clientWidth < 1100;
    this.ProjectList();
  },
  methods: {
    wenjuanChange(val) {
      console.log(this.CRFSurface);
      if (val) {
        const questionnaireName = this.CRFSurface.find(item => item.Id == val).questionnaireName;
        this.questionnaireName = questionnaireName;
      } else {
        this.questionnaireName = '';
      }
    },
    closeDialog() {
      this.$refs.naPai.dialogVisible = false;
      this.showNapai = false;
    },
    toNapai() {
      this.showNapai = true;
      // 拿项目的id
      this.ProjectId = this.value;
      console.log(this.ProjectId);
      this.$nextTick(() => {
        this.$refs.naPai.dialogVisible = true;
      });
    },
    ProjectChange(e) {
      this.questionnaireName = '';
      this.Project.forEach(project => {
        if (project.Id == e) {
          this.projectName = project.Name;
        }
        // 清空
        this.Questionnairevalue = '';
      });
      const ParameterProject = {
        ProjectId: e
      };
      // 查询当前项目问卷
      derive.CRFSurfaceData(ParameterProject).then(res => {
        if (res.data.Status == 1) {
          this.CRFSurface = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
      console.log(this.projectName);
      console.log(this.Project);
      this.StatisticsPart(e);
    },
    //项目
    async ProjectList() {
      derive.ProjectListData().then(res => {
        if (res.data.Status == 1) {
          this.Project = res.data.Data;
          this.Project.unshift({
            Name: '全部',
            Id: 'all'
          });
          this.value = 'all';
          this.StatisticsPart(this.value);
        } else {
          alert(res.data.Message);
        }
      });
    },
    StatisticsPart(value) {
      let parameter = {
        ProjectId: value
      };
      Statistics.StatisticsPart1Data(parameter).then(res => {
        if (res.data.Status == 1) {
          console.log(res.data);
          this.NumberOfPatients = res.data.Data;
          this.arrlist = [
            { name: '随访总数', value: this.NumberOfPatients.PatientTotal },
            { name: '本季数', value: this.NumberOfPatients.PatientQCallTotal },
            { name: '本月数', value: this.NumberOfPatients.PatientMCallTotal },
            { name: '本周', value: this.NumberOfPatients.PatientWCallTotal },
            { name: '最近', value: this.NumberOfPatients.PatientLCallTotal }
          ];
          // this.Part5 = [
          //   { name: "本季数", value: this.NumberOfPatients.PatientQCallTotal },
          //   { name: "本月数", value: this.NumberOfPatients.PatientMCallTotal },
          //   { name: "本周数", value: this.NumberOfPatients.PatientWCallTotal },
          //   { name: "最近3天", value: this.NumberOfPatients.PatientLCallTotal },
          // ];
          this.total = this.NumberOfPatients.PatientYCallTotal;
          this.$nextTick(() => {
            this.statisticListD();
          });
          this.followNumber = ArrayZero(this.NumberOfPatients.PatientCallTotal, 7);
          console.log(this.followNumber);
        } else {
          alert(res.data.Message);
        }
      });
      Statistics.StatisticsPart2Data(parameter).then(res => {
        if ((res.data.Status = 1)) {
          this.Part1 = res.data.Data.Part1;
          this.Part2 = res.data.Data.Part2;
          this.Part3 = res.data.Data.Part3;
          this.Part4 = res.data.Data.Part4;
          this.Part5 = res.data.Data.Part5;
          let arr = [];
          this.Part5.forEach(i => {
            let obj = {
              value: i.m,
              name: i.p
            };
            this.total2 += i.m;
            arr.push(obj);
          });
          this.Part5 = arr;
          this.Part6 = res.data.Data.Part6;
          this.$nextTick(() => {
            setTimeout(() => {
              this.statisticListSF();
            }, 10);
            // this.statisticListSF()
            this.statisticListA();
            this.statisticListB();
            this.statisticListC();
            // this.statisticListC1()
            this.statisticListD();
            this.StaisticsMap();
          });
        } else {
          alert(res.data.Message);
        }
      });
      Statistics.StatisticsPart3Data(parameter).then(res => {
        if (res.data.Status == 1) {
          // this.NoticeMsg=res.data.Data.NoticeMsg
          // this.TraceMsg=res.data.Data.TraceMsg
          // this.Part4 = res.data.Data.map((item) => {
          //   return {
          //     value: item.Count,
          //     name: item.StatusName,
          //   };
          // });
          this.$nextTick(() => {
            this.statisticListB();
          });
        } else {
          alert(res.data.Message);
        }
      });
    },
    load() {},
    load2() {},
    statistResize(chartDom, myChart) {
      // 表格的自适应
      var width = document.documentElement.clientWidth;
      if (width <= 1600) {
        chartDom.style.width = '360px';
      } else {
        chartDom.style.width = '470px';
      }
      // window.onresize = myChart.resize;
      myChart.resize();
    },
    statisticListA() {
      var chartDom = document.getElementById('staisticsA');
      var myChart = echarts.init(chartDom);
      let arr = [
        {
          name: '男',
          type: 'bar',
          barGap: 0,
          emphasis: {
            focus: 'series'
          },
          data: []
        },
        {
          name: '女',
          type: 'bar',
          barGap: 0,
          emphasis: {
            focus: 'series'
          },
          data: []
        }
      ];
      this.statistResize(chartDom, myChart);
      this.Part1.forEach(i => {
        arr[0].data.push(i.m_Item1);
        arr[1].data.push(i.m_Item2);
      });
      var option;
      option = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { top: '15%', right: '0%', left: '8%', bottom: '12%' },
        xAxis: [
          {
            type: 'category',
            data: ['0-10', '11-20', '21-30', '31-40', '41-50', '51-60', '61-70', '70-80', '80以上'],
            axisLine: { lineStyle: { color: '#EEEEEE' } },
            axisLabel: {
              margin: 10,
              color: '#999999',
              rotate: 20, //角度顺时针计算的
              textStyle: { fontSize: 11 }
            },
            axisTick: { show: false }
          }
        ],
        yAxis: [
          {
            axisLabel: { formatter: '{value}', color: '#999999' },
            axisTick: { show: false },
            axisLine: {
              show: false,
              lineStyle: { color: 'rgba(0,186,255,.6)' }
            },
            splitLine: { lineStyle: { color: '#EEEEEE' } }
          }
        ],
        series: arr
      };
      option && myChart.setOption(option);
    },
    statisticListB() {
      let chartDom = document.getElementById('staisticsB');
      let myChart = echarts.init(chartDom);
      let option;
      let arr1 = [],
        arr2 = [];
      this.Part4.forEach(i => {
        arr1.push(i.m);
        arr2.push(i.p);
      });
      option = {
        // title: {
        //     text: '散点图',
        //     top: 20, // 定位
        //     left: 20, // 定位
        //     textStyle: {
        //         color: '#28354C',  //标题颜色
        //         // fontSize:'36',
        //     },
        // },
        xAxis: {
          type: 'category',
          data: arr2,
          axisLabel: {
            textStyle: {
              color: '#62B4BB'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '3%',
          containLabel: true
        },
        axisLabel: {
          fontSize: 12,
          formatter: function (value) {
            if (value.length > 2) {
              return value.substr(0, 5) + '...';
            } else {
              return value;
            }
          }
        },
        series: [
          {
            type: 'bar',
            data: arr1,
            showBackground: true,
            barWidth: '50%',
            color: '#44D4A8' // 线条颜色
          }
        ]
      };
      myChart.setOption(option);
    },
    statisticListC() {
      var chartDom = document.getElementById('staisticsC');
      var myChart = echarts.init(chartDom);
      this.statistResize(chartDom, myChart);
      var category = ['0-10', '11-20', '21-30', '31-40', '41-50', '51-60', '61-70', '70-80', '80以上'];
      var barData = this.Part2;
      var option;
      option = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '4%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: '#EEEEEE' } }
          }
        ],
        yAxis: [
          {
            type: 'category',
            data: category,
            axisTick: { show: false },
            axisLine: { show: false },
            splitLine: { show: false },
            offset: 10,
            nameTextStyle: {
              fontSize: 15
            }
          }
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            data: barData,
            barGap: 10,
            smooth: true,
            barWidth: 16,
            label: {
              normal: {
                show: true,
                position: 'right',
                offset: [5, -2],
                textStyle: {
                  color: '#47A1Ff',
                  fontSize: 13
                }
              }
            },
            itemStyle: {
              emphasis: { barBorderRadius: 7 },
              normal: {
                barBorderRadius: 7,
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    { offset: 0, color: '#5FACFE' }, // 0% 处的颜色
                    { offset: 1, color: '#A5D0FF' } // 100% 处的颜色
                  ],
                  false
                )
              }
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    statisticListC1() {
      var chartDom = document.getElementById('staisticsC1');
      var myChart = echarts.init(chartDom);
      this.statistResize(chartDom, myChart);
      var category = ['10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80以上'];
      var barData = this.Part3;
      var option;
      option = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '4%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: '#EEEEEE' } }
          }
        ],
        yAxis: [
          {
            type: 'category',
            data: category,
            axisTick: { show: false },
            axisLine: { show: false },
            splitLine: { show: false },
            offset: 10,
            nameTextStyle: {
              fontSize: 15
            }
          }
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            data: barData,
            barGap: 10,
            smooth: true,
            barWidth: 16,
            label: {
              normal: {
                show: true,
                position: 'right',
                offset: [5, -2],
                textStyle: {
                  color: '#47A1Ff',
                  fontSize: 13
                }
              }
            },
            itemStyle: {
              emphasis: { barBorderRadius: 7 },
              normal: {
                barBorderRadius: 7,
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    { offset: 0, color: '#5FACFE' }, // 0% 处的颜色
                    { offset: 1, color: '#A5D0FF' } // 100% 处的颜色
                  ],
                  false
                )
              }
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    statisticListD() {
      //AI电话接通数
      var chartDom = document.getElementById('staisticsD');
      var myChart = echarts.init(chartDom);
      var option;
      var list = this.Part5;
      option = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        title: {
          text: this.total2,
          subtext: '入院人数',
          textStyle: {
            fontSize: 30,
            color: '#319EFD',
            lineHeight: 20
          },
          subtextStyle: {
            fontSize: 16,
            color: '#333'
          },
          textAlign: 'center',
          left: '24%',
          top: '40%'
        },
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'left',
          icon: 'circle',
          top: '35%',
          left: '61%',
          y: 'center',
          textStyle: {
            color: '#333333',
            fontSize: 14
          },
          formatter(name) {
            for (var i = 0; i < list.length; i++) {
              if (name == list[i].name) {
                return name + '   ' + list[i].value;
              }
            }
          }
        },
        color: ['#319efd', '#3becf2', '#ff718e', '#ffdb00'],
        series: [
          {
            name: '随访总数',
            type: 'pie',
            radius: ['45%', '60%'],
            avoidLabelOverlap: false,
            center: ['25%', '50%'],
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: { show: false, position: 'center' },
            // emphasis: {label: {show: true, fontSize: '40', fontWeight: 'bold'}}, labelLine: {show: false},
            data: this.Part5
          }
        ]
      };
      option && myChart.setOption(option);
    },
    statisticListSF() {
      var chartDom = document.getElementById('staisticsSF');
      var myChart = echarts.init(chartDom);
      var option;
      var series = [];
      var pieDatas = this.arrlist;
      var maxRadius = this.devicePixelRatio ? '50' : '80',
        barWidth = 8,
        barGap = 5;
      var arr = [];
      pieDatas.forEach((item, index) => {
        arr.push(item.value);
      });
      var maxValue = Math.max(...arr);
      var showValue = true,
        showPercent = true;
      var barColor = [
        {
          color1: 'rgb(251, 86, 86)',
          color2: ''
        },
        {
          color1: 'rgb(255, 165, 0)',
          color2: ''
        },
        {
          color1: 'rgb(69, 159, 255)',
          color2: ''
        },
        {
          color1: 'rgb(89, 232, 212)',
          color2: ''
        },
        {
          color1: 'rgb(133, 107, 255)',
          color2: ''
        }
      ];
      pieDatas.map((item, i) => {
        series.push({
          type: 'pie',
          clockWise: true, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          // coordinateSystem:'polar',
          radius: [maxRadius - i * (barGap + barWidth) + '%', maxRadius - (i + 1) * barWidth - i * barGap + '%'],
          center: ['30%', '50%'],
          label: {
            show: false
          },
          itemStyle: {
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            borderWidth: 5,
            borderRadius: 10
          },
          data: [
            {
              value: item.value,
              name: item.name,
              itemStyle: {
                color: (barColor[i] && barColor[i].color1) || 'rgba(68,165,255,1)'
              }
            },
            {
              value: maxValue - item.value,
              name: '',
              itemStyle: {
                color: 'transparent'
              },
              tooltip: {
                show: false
              },
              hoverAnimation: true
            }
          ]
        });
        series.push({
          name: 'blank',
          type: 'pie',
          silent: true,
          z: 0,
          clockWise: true, //顺时加载
          hoverAnimation: true, //鼠标移入变大
          radius: [maxRadius - i * (barGap + barWidth) + '%', maxRadius - (i + 1) * barWidth - i * barGap + '%'],
          center: ['50%', '50%'],
          label: {
            show: false
          },
          itemStyle: {
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            borderWidth: 5
          },
          data: [
            {
              value: 1,
              itemStyle: {
                color: 'rgba(255, 255, 255,.13)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }
          ]
        });
      });

      var option;
      option = {
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        backgroundColor: 'transparent',
        tooltip: {
          show: true,
          trigger: 'item'
        },
        legend: {
          show: true,
          left: '60%',
          top: 'middle',
          icon: 'circle',
          itemWidth: 15,
          itemHeight: 20,
          itemGap: 10,
          textStyle: {
            fontSize: 16,
            color: '#000'
          },
          formatter: name => {
            var datas = pieDatas;
            let total = 0;
            datas.map(item => {
              total += item.value - 0;
            });
            let valueIndex = datas.map(item => item.name).indexOf(name);
            return name + (name.length == 4 ? '' : name.length == 3 ? '   ' : '      ') + (showValue ? datas[valueIndex].value + (option.legendValueUnit || '') + ' ' : '');
            // + (showValue ? datas[valueIndex].value + (option.legendValueUnit || '') + ' ' : '')
          }
        },
        series: series
      };

      option && myChart.setOption(option);
    },

    StaisticsMap() {
      // 患者分布区域--飞线点数据
      var chinaDatas = [];
      for (var i = 0; i < this.Part6.length; i++) {
        chinaDatas.push([
          {
            name: this.Part6[i].p,
            value: this.Part6[i].m
          }
        ]);
      }
      this.initMapInfo(chinaDatas);
    },

    initMapInfo(chinaDatas) {
      // 地图数据
      var chinaGeoCoordMap = {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.9236, 43.5883],
        西藏: [91.11, 29.97],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        上海: [121.4648, 31.2891],
        澳门: [113.5, 22.2],
        台湾: [121.5091, 25.0443],
        香港: [114.1733, 22.32]
      };
      let formdata = '重庆'; // 中心点

      var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var dataItem = data[i];
          var fromCoord = chinaGeoCoordMap[dataItem[0].name];
          var toCoord = [108.384366, 30.439702]; //中心点地理坐标
          if (fromCoord && toCoord && dataItem[0].value > 0) {
            res.push([
              {
                // 飞线从哪里出发
                coord: fromCoord,
                value: dataItem[0].value
              },
              {
                // 飞线去往哪里
                coord: toCoord
              }
            ]);
          }
        }
        return res;
      };
      var series = [];

      [[formdata, chinaDatas]].forEach(function (item, i) {
        series.push(
          {
            type: 'lines',
            coordinateSystem: 'geo',
            zlevel: 2,
            effect: {
              show: true,
              period: 4, //箭头指向速度，值越小速度越快
              trailLength: 0, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: 'arrow', //箭头图标
              symbolSize: 5, //图标大小
              color: '#fcdd6e' // 图标颜色
            },
            lineStyle: {
              normal: {
                show: true,
                width: 1, //尾迹线条宽度
                opacity: 1, //尾迹线条透明度
                curveness: 0.3, //尾迹线条曲直度
                color: '#fcdd6e' // 飞线颜色
              },
              color: '#fcdd6e'
            },
            data: convertData(item[1])
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              //涟漪特效
              period: 4, //动画时间，值越小速度越快
              brushType: 'stroke', //波纹绘制方式 stroke, fill
              scale: 3, //波纹圆环最大限制，值越大波纹越大
              color: '#fcdd6e'
            },
            label: {
              normal: {
                show: false,
                position: 'right', //显示位置
                offset: [5, 0], //偏移设置
                formatter: function (params) {
                  //圆环显示文字
                  return params.data.name;
                },
                fontSize: 13
              },
              emphasis: {
                show: false
              }
            },
            symbol: 'circle',
            symbolSize: function (val) {
              return 5; //圆环大小
            },
            itemStyle: {
              normal: {
                show: false,
                color: '#fce182'
              }
            },
            data: item[1].map(function (dataItem) {
              return {
                //在这里定义你所要展示的数据
                name: dataItem[0].name,
                value: chinaGeoCoordMap[dataItem[0].name].concat([dataItem[0].value])
              };
            })
          },
          //中心点
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 15,
            rippleEffect: {
              period: 4,
              brushType: 'stroke',
              scale: 4,
              color: '#38ff85'
            },
            label: {
              normal: {
                show: false,
                position: 'right',
                //offset:[5, 0],
                color: '#38ff85',
                formatter: '{b}',
                textStyle: {
                  color: '#38ff85'
                }
              },
              emphasis: {
                show: false,
                color: '#38ff85'
              }
            },
            symbol: 'circle',
            symbolSize: 5,
            itemStyle: {
              color: '#38ff85'
            },
            data: [
              {
                name: item[0],
                value: chinaGeoCoordMap[item[0]].concat([10])
              }
            ]
          }
        );
      });
      this.initMap(series);
    },
    initMap(series) {
      let myChart = echarts.init(document.getElementById('StaisticsMap'));
      let option = {
        // bgColor: '#1a1e45',
        legend: {
          orient: 'horizontal', //图例的排列方向
          // textStyle: { color: '#1a1e45' },
          x: 'left', //图例的位置
          y: '-20000000000000'
        },
        visualMap: {
          //颜色的设置  dataRange
          // textStyle: { color: '#1a1e45' },
          x: 'left',
          y: 'bottom',
          // splitList: [{ start: 0, end: 150000 }],
          show: false
          // text:['高','低'],// 文本，默认为数值文本
          // color: ['#1a1e45'],
        },
        geo: {
          map: 'china',
          zoom: 1.2,
          label: {
            normal: {
              show: true,
              textStyle: {
                color: '#FFFFFF'
              }
            },
            emphasis: {
              show: false
            }
          },
          roam: true, //是否允许缩放
          itemStyle: {
            normal: {
              color: '#1a1e45', //地图背景色
              borderColor: '#22ccfb', //省市边界线00fcff 516a89
              borderWidth: 1,
              textStyle: '#fff'
            },
            emphasis: {
              color: '#22ccfb' //悬浮背景
            }
          },
          data: []
        },
        tooltip: {
          show: true, //鼠标移入是否触发数据
          trigger: 'item', //触发方式,
          formatter: '人数：{c}', //提示框浮层内容格式器
          backgroundColor: 'rgba(0,0,0,0.7)', //背景颜色（此时为默认色）
          borderRadius: 4, //边框圆角
          textStyle: {
            color: '#fff'
          }
        },
        series: series
      };

      myChart.setOption(option);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/mixin.scss';

.statistics-title {
  display: flex;

  span:nth-child(1) {
    width: 3px;
    height: 12px;
    background: #3388ff;
    border-radius: 164px;
    margin-top: 5px;
    margin-right: 5px;
  }

  span:nth-child(2) {
    @include add-size($font_size_16);
    font-weight: 400;
    color: #333;
  }
}

.tolead {
  width: 100%;
  min-width: 1440px;
  height: 100%;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px 20px 0px 30px;
  overflow: hidden;
  overflow: auto;
  // background: red;
  background: #f0f7fd;

  .statistics-patient {
    min-width: 694px;
    flex: 1;
    min-height: 280px;
    aspect-ratio: 694 / 280;
    background: rgba(255, 255, 255, 0.31);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;
    margin-right: 30px;

    .patient-top {
      display: flex;
      margin: 5px;

      .patient-content {
        box-sizing: border-box;
        padding: 20px 20px 0 20px;
        color: #ffffff;

        .report-flex {
          display: flex;
          justify-content: space-between;

          img {
            margin-top: 20px;
          }
        }

        span:nth-child(1) {
          @include add-size5($font_size_14);
          font-weight: 400;
        }

        p {
          @include add-size3($font_size_34);
          font-weight: 400;
        }
      }

      & > div {
        min-width: 194px;
        flex: 1;
        min-height: 100px;
        aspect-ratio: 194 / 100;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin: 10px 18px 0 10px;
      }

      & > div:nth-child(1) {
        background: linear-gradient(to right, #00cfe6 0%, #17ebd5 100%);
      }

      & > div:nth-child(2) {
        background: linear-gradient(to right, #ff9a00 0%, #ffe800 100%);
      }

      & > div:nth-child(3) {
        background: linear-gradient(to right, #59caff 0%, #2f94ff 100%);
        margin-right: 0;
      }
    }

    .patient-bottom {
      display: flex;
      margin: 5px;

      .patient-content {
        box-sizing: border-box;
        padding: 20px 20px 0 20px;
        color: #ffffff;

        .report-flex {
          display: flex;
          justify-content: space-between;

          img {
            margin-top: 20px;
          }
        }

        span:nth-child(1) {
          @include add-size5($font_size_14);
          font-weight: 400;
        }

        p {
          @include add-size3($font_size_34);
          font-weight: 400;
        }
      }

      & > div {
        flex: 1;
        min-width: 140px;
        min-height: 100px;
        aspect-ratio: 7 / 5;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin: 10px 15px 0 10px;
      }

      & > div:nth-child(1) {
        background: linear-gradient(to right, #ff8eb3 0%, #ff589b 100%);
      }

      & > div:nth-child(2) {
        background: linear-gradient(to right, #7e5cff 0%, #9b93ff 100%);
      }

      & > div:nth-child(3) {
        background: linear-gradient(to right, #ffb45b 0%, #ff9f13 100%);
      }

      & > div:nth-child(4) {
        background: linear-gradient(to right, #a582f9 0%, #cb69fd 100%);
        margin-right: 0;
      }
    }
  }

  .total-number {
    min-width: 500px;
    flex: 1;
    min-height: 280px;
    aspect-ratio: 500 / 280;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;

    span {
      @include common_span;
    }

    .follow-number {
      width: 40px;
      height: 40px;
      font-size: 30px;
      text-align: center;
      color: #ffffff;
      background: linear-gradient(180deg, #496cf3 0%, #819dfe 100%);
      border-radius: 6px 6px 6px 6px;
      margin-right: 12px;
    }

    .bottomdiv {
      flex-grow: 1;
      background-image: url('../../assets/image/taskmanagement/dataRepotrBg.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 80%;
    }
  }

  .statistics-img-content {
    min-width: 600px;
    flex: 1;
    min-height: 280px;
    aspect-ratio: 600 / 280;
    background: rgba(255, 255, 255, 0.31);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;
  }

  .statistics_middle {
    width: 100%;
    min-height: 650px;
    display: flex;

    .statistics_middle_left {
      min-width: 1044px;
      flex: 1;
      min-height: 650px;
      aspect-ratio: 1044 / 650;
      //  background: #2F94FF;
    }

    .statistics_middle_right {
      min-width: 800px;
      flex: 1;
      min-height: 640px;
      aspect-ratio: 800 / 480 !important;
      background: rgba(255, 255, 255, 0.39);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      box-sizing: border-box;
      padding: 15px;
    }
  }
}

// 横屏
@media screen and (-webkit-min-device-pixel-ratio: 1.5) and (orientation: landscape) {
  .tolead {
    min-width: 0 !important;

    .statistics-patient {
      min-width: 0 !important;

      .patient-top {
        div {
          min-width: 0 !important;

          // margin: 10px 18px 0 0px !important;
          .patient-content {
            padding: 20px 5px 0 5px !important;
          }
        }
      }

      .patient-bottom {
        div {
          min-width: 0 !important;
          margin: 10px 3px 0 0px !important;

          .patient-content {
            padding: 5px 0px 0 5px !important;
          }
        }
      }
    }

    .total-number {
      min-width: 0 !important;
    }

    .statistics-img-content {
      min-width: 0 !important;

      #staisticsSF {
        width: 100% !important;

        div:nth-child(1) {
          width: 100% !important;
        }
      }
    }

    .statistics_middle {
      flex-direction: column;

      .statistics_middle_left {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        min-width: 0 !important;
        min-height: 0 !important;
        margin-right: 20px;
        width: 100% !important;
        aspect-ratio: 0 !important;

        #staisticsA {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        #staisticsB {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        #staisticsC {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        #staisticsD {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        // .staisticsB{
        //   margin-bottom: 20px;
        // }

        // div{
        //   width: 48% !important;
        // }
      }

      .statistics_middle_right {
        width: 100% !important;
        min-width: 0 !important;
        margin-top: 20px;
        height: 640px;

        #StaisticsMap {
          width: 100% !important;
          height: 100% !important;
          // max-height: 100%;
          min-width: 0 !important;
          min-height: 0 !important;
          // aspect-ratio:0 !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }
      }
    }
  }
}

//竖屏
@media screen and (-webkit-min-device-pixel-ratio: 1.5) and (orientation: portrait) {
  .tolead {
    min-width: 0 !important;

    .topDiv {
      flex-wrap: wrap;
      // flex-direction: column;

      .statistics-patient {
        width: 100%;
        min-width: 0 !important;
        flex: none !important;
      }

      .total-number {
        width: 48%;
        min-width: 0 !important;
        margin-top: 10px;
      }

      .statistics-img-content {
        margin-top: 10px;
        width: 48%;
        min-width: 0 !important;

        #staisticsSF {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }
      }
    }

    .statistics_middle {
      min-width: 0 !important;
      flex-direction: column;

      .statistics_middle_left {
        min-width: 0 !important;

        #staisticsA {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        #staisticsC {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        #staisticsB {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }

        #staisticsD {
          width: 100% !important;

          div:nth-child(1) {
            width: 100% !important;
          }
        }
      }

      .statistics_middle_right {
        min-width: 0 !important;
        width: 100% !important;
        margin-top: 10px;
        overflow: hidden;

        #StaisticsMap {
          width: 100% !important;

          div:ntn-child(1) {
            width: 100% !important;
            aspect-ratio: 0 !important;
          }
        }
      }
    }
  }
}
</style>
